
import { filter } from 'rxjs/operators';
import { Component } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { WireReportService, WireReportTypes } from './wire-report.service';
import { WireComponentTabEnum, WireService } from '../../services/wire.service';
import { WireModel } from '../../models/wire.model';
import { TabsStyleTypesEnum } from '../../../../Common/Layout/enums/tabs-types.enum';
import { AttributeModel } from '../../../../Common/Misc/models/attribute.model';
import { ReleaseStatus } from '../../../../api/wire/enums/release-status.enum';
import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { WireExportDialogComponent } from '../WireExportDialog/wire-export-dialog.component';
import { ReleaseStatsModel } from '../../models/release-stats.model';
import { ProgressModel } from '../../../../Common/Dialogs/models/progress.model';
import { Title } from '@angular/platform-browser';
import { LocalizationService } from '../../../../Core/Localization/services/localization.service';


@Component({
    selector: 'agpr-wire-report',
    templateUrl: './wire-report.component.html',
    styleUrls: ['wire-report.component.scss'],
    standalone: false
})
export class WireReportComponent {

    wire: WireModel;
    wireLoading: boolean = false;
    selectedTabIndex: number = WireReportTypes.performance;
    performanceReport: ReleaseStatsModel;
    sideExpanded: boolean = false;
    wireAttributes: AttributeModel[] = [];
    rhpSelectedTabIndex: WireComponentTabEnum;
    overlayContainer: Element;

    subscriptions: Subscription[] = [];
    readonly defaultSelectedTabIndex: number = 0;
    readonly tabsStyleTypes = TabsStyleTypesEnum;
    readonly wireReportTypes = WireReportTypes;
    readonly releaseStatus = ReleaseStatus;

    constructor(
        public wireService: WireService,
        public wireReportService: WireReportService,
        public coreDialogService: CoreDialogService,
        public titleService: Title,
        public localizationService: LocalizationService
    ) {
        this.subscriptions.push(
            this.wireService.loading$.subscribe(wireLoading => this.wireLoading = wireLoading),
            this.wireService.currentResource$.subscribe(wire => {
                this.wire = wire;
                if (wire) {
                    this.titleService.setTitle(
                        this.localizationService.transform('Amplify.newswire.browserTitle.name', {name: wire.name})
                    );
                }
            }),
            this.wireService.wireAttributes$.subscribe(attributes => this.wireAttributes = attributes),
            this.wireReportService.getPerformanceReport().subscribe(performanceReport => {
                if (performanceReport) {
                    if (Object.keys(performanceReport).length){
                        this.performanceReport = performanceReport;
                    }
                } else {
                    this.performanceReport = null;
                }
            })
        );
        this.rhpSelectedTabIndex = this.defaultSelectedTabIndex;
        this.overlayContainer = document.getElementById('main-content');
    }

    tabChange(index: WireReportTypes) {
        this.selectedTabIndex = index;
        this.rhpSelectedTabIndex = this.defaultSelectedTabIndex;
    }

    exportReport() {
        this.coreDialogService.open(WireExportDialogComponent);
    }
}
